var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderTop'),_c('div',{staticClass:"main-bg"},[_c('div',{staticClass:"main"},[_c('router-view',{staticClass:"router-view"}),_c('Footer')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }